import React from 'react';
import Box from '@mui/material/Box';
import { Button } from '../Button';

export type StepperControlsProps = {
    onNext?: () => void;
    onPrevious?: () => void;
    onNextLabel?: string;
    onPreviousLabel?: string;
    disableNext?: boolean;
    idNext?: string;
    idPrevious?: string;
};

const StepperControls = (props: StepperControlsProps): JSX.Element => {
    const {
        onNext,
        onPrevious,
        onNextLabel = 'dalje',
        onPreviousLabel = 'nazad',
        disableNext,
        idNext,
        idPrevious,
    } = props;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '95%', paddingTop: '15px' }}>
            {onPrevious ? <Button onClickHandler={onPrevious} label={onPreviousLabel} id={idPrevious} /> : <div />}
            {onNext ? (
                <Button onClickHandler={onNext} label={onNextLabel} disabled={disableNext} id={idNext} />
            ) : (
                <div />
            )}
        </Box>
    );
};

export default StepperControls;
